export default /* graphql */ `
fragment seo on SeoTags {
  sys { id }
  title
  description
  keywords
  noindex
  nofollow
}
`
